module.exports = __webpack_public_path__ + "static/media/grey.74f7cdff.png";